// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Time48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Time48: FC<Time48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
            viewBox="0 0 48 48"
        >
            <path d="m30.6 33.4 2.8-2.8-7.4-7.4V14h-4v10.8zM24 44q-4.15 0-7.8-1.576-3.65-1.574-6.35-4.274T5.576 31.8Q4 28.15 4 24t1.576-7.8T9.85 9.85q2.7-2.7 6.35-4.276Q19.85 4 24 4t7.8 1.574q3.65 1.576 6.35 4.276t4.274 6.35T44 24q0 4.15-1.576 7.8-1.574 3.65-4.274 6.35t-6.35 4.274T24 44m0-4q6.65 0 11.326-4.674Q40 30.65 40 24t-4.674-11.326Q30.65 8 24 8t-11.324 4.674Q8 17.35 8 24t4.676 11.326Q17.349 40 24 40" />
        </svg>
    );
};

export default Time48;
